import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export const groupedInclusionPatientStatusSchema = z.literal(["doctor_draft", "visible_by_doctor"]);
export type GroupedInclusionPatientStatus = z.output<typeof groupedInclusionPatientStatusSchema>;

export type GroupedInclusionPatient = {
  id: string;
  firstName: string;
  lastName: string;
  status: "visible_by_doctor";
  email?: string;
  phoneNumber?: string;
};

export const groupedInclusionPatientModelSchema: Schema<GroupedInclusionPatient> = cz.camelCaseObject({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  status: z.literal("visible_by_doctor"),
  email: cz.optional(z.string()),
  phone_number: cz.optional(z.string()),
});

export type GroupedInclusionDraft = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  status: "doctor_draft";
};

export const groupedInclusionDraftSchema: Schema<GroupedInclusionDraft> = cz.camelCaseObject({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  phone_number: cz.optional(z.string()),
  status: z.literal("doctor_draft"),
});

export type BulkCreateGroupedInclusionItem = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  libreviewId?: string;
};

export type BulkCreateGroupedInclusionCreatedEntry = {
  id: string;
  email: string;
  status: GroupedInclusionPatientStatus;
};

const bulkCreateGroupedInclusionCreatedEntrySchema: Schema<BulkCreateGroupedInclusionCreatedEntry> = cz.camelCaseObject(
  {
    id: z.string(),
    email: z.string(),
    status: groupedInclusionPatientStatusSchema,
  },
);

export type BulkCreateGroupedInclusionFailedEntry = {
  email: string;
  reason: string;
};

const bulkCreateGroupedInclusionFailedEntrySchema: Schema<BulkCreateGroupedInclusionFailedEntry> = cz.camelCaseObject({
  email: z.string(),
  reason: z.string(),
});

export type BulkCreateGroupedInclusionResponse = {
  created: BulkCreateGroupedInclusionCreatedEntry[];
  failed: BulkCreateGroupedInclusionFailedEntry[];
};

export const bulkCreateGroupedInclusionResponseSchema: Schema<BulkCreateGroupedInclusionResponse> = cz.camelCaseObject({
  created: cz.forcedArray(bulkCreateGroupedInclusionCreatedEntrySchema),
  failed: cz.forcedArray(bulkCreateGroupedInclusionFailedEntrySchema),
});

export type BulkSubmitGroupedInclusionDraftsFailedEntry = {
  id: string;
  reason: string;
};

const bulkSubmitGroupedInclusionDraftsFailedEntrySchema: Schema<BulkSubmitGroupedInclusionDraftsFailedEntry> =
  cz.camelCaseObject({
    id: z.string(),
    reason: z.string(),
  });

export type BulkSubmitGroupedInclusionDraftsResponse = {
  submitted: string[];
  failed: BulkSubmitGroupedInclusionDraftsFailedEntry[];
};

export const bulkSubmitGroupedInclusionDraftsResponseSchema: Schema<BulkSubmitGroupedInclusionDraftsResponse> =
  cz.camelCaseObject({
    submitted: cz.forcedArray(z.string()),
    failed: cz.forcedArray(bulkSubmitGroupedInclusionDraftsFailedEntrySchema),
  });
